import script from "./CalculationViewLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalculationViewLink.vue?vue&type=script&setup=true&lang=ts"

import "./CalculationViewLink.vue?vue&type=style&index=0&id=5826dc97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5826dc97"]])

export default __exports__